'use client';

import { useTranslations } from 'next-intl';

interface IClearSearchHistoryModalProps {
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function ClearSearchHistoryModal(props: IClearSearchHistoryModalProps) {
    const { visible, onCancel, onConfirm } = props;
    const t = useTranslations('Discover');
    const tCommon = useTranslations('Common');

    if (!visible) {
        return null;
    }

    return (
        /* 弹窗遮罩层 */
        <div
            className='fixed inset-0 z-[1000] flex items-center justify-center bg-[rgba(0,0,0,0.45)]'
            onClick={onCancel}
        >
            {/* 弹窗容器 */}
            <div
                className='w-[291px] rounded-[16px] bg-[#FFFFFF]'
                onClick={e => e.stopPropagation()}
                role='dialog'
                aria-modal='true'
            >
                {/* 弹窗内容区域 */}
                <div className='h-[80px] px-[20px] pb-[16px] pt-[24px] text-center'>
                    <p className='text-[14px] leading-[20px] text-[#000000]'>{t('search_clear_history_title')}</p>
                </div>

                {/* 弹窗底部按钮区域 */}
                <div className='flex w-[291px] border-t border-[#F3F4F6]'>
                    {/* 取消按钮 */}
                    <button
                        type='button'
                        onClick={onCancel}
                        className='h-[58px] w-[147px] text-[16px] leading-[22px] text-[#B2B2B2]'
                    >
                        {tCommon('cancel')}
                    </button>

                    {/* 删除按钮 */}
                    <button
                        type='button'
                        onClick={onConfirm}
                        className='h-[58px] w-[148px] text-[16px] leading-[22px] text-[#EF2C2C]'
                    >
                        {t('search_clear_history_delete')}
                    </button>
                </div>
            </div>
        </div>
    );
}
